import StoreConnector from '@/helpers/StoreConnector'
import ChangeOrderApi from 'api-client/ChangeOrder'
import ChangeOrderAuditApi from 'api-client/ChangeOrderAudit.api'
import { EventBus } from '@/plugins/event-bus'

const ChangeOrderService = {
  type: 'changeOrder',
  async getChangeOrders(page, includeNationWide, searchQuery) {
    try {
      const result = await ChangeOrderApi.getChangeOrders(page, includeNationWide, searchQuery)
      StoreConnector.dispatch('changeOrder/addChangeOrders', result)
      return Promise.resolve()
    } catch (e) {
      EventBus.$emit('notification-warning', 'changeordersgetfailed')
      // always resolve the promise. Else we get an endless loader
      return Promise.resolve()
    }
  },
  async createChangeOrder() {
    try {
      const changeOrder = await StoreConnector.getOnce('changeOrder/get')

      const createOrderResult = await ChangeOrderApi.createChangeOrder(changeOrder)
      await StoreConnector.dispatch('changeOrder/setChangeOrder', createOrderResult)
      return createOrderResult
    } catch (e) {
      EventBus.$emit('notification-warning', 'Er is een fout opgetreden...')
      return Promise.resolve()
    }
  },
  async updateChangeOrder() {
    const changeOrder = await StoreConnector.getOnce('changeOrder/get')
    const ponId = await StoreConnector.getOnce('user/userName')

    try {
      const result = await ChangeOrderApi.updateChangeOrder(changeOrder, ponId)
      await StoreConnector.dispatch('changeOrder/setChangeOrder', result)
      EventBus.$emit('notification-success', 'Wijzig auto bestelling is opgeslagen...')
    } catch (e) {
      EventBus.$emit('notification-warning', 'Er is een fout opgetreden...')
      return Promise.resolve()
    }
  },
  async verifyOrder() {
    const changeOrder = StoreConnector.getOnce('changeOrder/get')

    // No catch here: callers decide how a failed verification is presented
    let optionCodes = changeOrder.CarConfiguration.ChangedOptions.map(function (item) {
      return item.Id
    })

    let typeOption = changeOrder.CarConfiguration.OkapiTypeCode
    let modelYearOption = 'MODELYEAR:' + changeOrder.CarConfiguration.ModelYear

    optionCodes.push(typeOption)
    optionCodes.push(modelYearOption)

    let modelNumber = changeOrder.CarConfiguration.OkapiModelCode.split('_')[1]

    return await ChangeOrderApi.verifyChangeOrder(optionCodes, modelNumber)
  },
  resetChangeOrders() {
    StoreConnector.dispatch('changeOrder/resetChangeOrders')
  },
  async deleteChangeOrder(changeOrderId) {
    try {
      await ChangeOrderApi.deleteChangeOrder(changeOrderId)
      return Promise.resolve()
    } catch (e) {
      EventBus.$emit('notification-warning', 'De wijzigingsorder kon niet worden verwijderd.')
      return Promise.resolve()
    }
  },
  async getChangeOrderByChangeOrderId(changeOrderId) {
    try {
      const result = await ChangeOrderApi.getChangeOrderByChangeOrderId(changeOrderId)
      StoreConnector.dispatch('changeOrder/setChangeOrder', result)
    } catch (e) {
      EventBus.$emit('notification-warning', 'changeeordersgetfailed')
      return null
    }
  },
  async getChangeOrderByKomNumber(komNumber, komYear, quoteId) {
    try {
      const result = await ChangeOrderApi.getChangeOrderByKomNumber(komNumber, komYear, quoteId)
      StoreConnector.dispatch('changeOrder/setChangeOrder', result)
      return result
    } catch (e) {
      StoreConnector.dispatch('changeOrder/clearChangeOrder')
      return Promise.reject(e)
    }
  },
  async tryOrder(changeOrderId) {
    try {
      return await ChangeOrderApi.previewChangeOrder(changeOrderId)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async submitChangeOrder(changeOrderId) {
    try {
      const response = await ChangeOrderApi.submitChangeOrder(changeOrderId)
      EventBus.$emit('notification-success', 'Wijzigingsorder verzonden')
      return response
    } catch (e) {
      EventBus.$emit('notification-warning', 'Er is een fout opgetreden')
      return Promise.reject(e)
    }
  },
  async submitChangeOrderSigning(changeOrderParams) {
    try {
      const response = await ChangeOrderApi.submitChangeOrderSigning(changeOrderParams)
      EventBus.$emit('notification-success', 'Wijzigingsorder PDF verstuurd')
      return response
    } catch (e) {
      EventBus.$emit('notification-warning', 'Er is een fout opgetreden')
      return Promise.reject(e)
    }
  },
  async getChangeOrderExcelResult(changeOrderId) {
    try {
      return await ChangeOrderApi.getChangeOrderExcelResult(changeOrderId)
    } catch (e) {
      EventBus.$emit(
        'notification-warning',
        'Er is een fout opgetreden bij het ophalen van het Excel resultaat'
      )
      return Promise.reject(e)
    }
  },

  async getChangeOrderEmailBody(changeOrderId) {
    try {
      return await ChangeOrderApi.getChangeOrderEmailBody(changeOrderId)
    } catch (e) {
      EventBus.$emit('notification-warning', 'Er is een fout opgetreden bij het ophalen de email')
      return Promise.reject(e)
    }
  },
  async getChangeOrderEmailInfoForDigitalSigning(changeOrderId) {
    try {
      return await ChangeOrderApi.getChangeOrderEmailInfoForDigitalSigning(changeOrderId)
    } catch (e) {
      EventBus.$emit(
        'notification-warning',
        'Er is een fout opgetreden bij het ophalen de sms-tekst'
      )
      return Promise.reject(e)
    }
  },
  async getAuditTrail(changeOrderId) {
    try {
      const response = await ChangeOrderAuditApi.getAuditTrail(changeOrderId)
      return response.data
    } catch (e) {
      EventBus.$emit(
        'notification-warning',
        'Er is een fout opgetreden bij het ophalen van de audittrail'
      )
      return Promise.reject(e)
    }
  },
}
export default ChangeOrderService
